import * as EnumHelper from 'js/common/enum_helper';

const {enums} = window.sn;
const {ContentMetadataCommentSource} = enums;

const ContentMetadataCommentSourceCssClasses = EnumHelper.enumValuesToCssClasses(
    ContentMetadataCommentSource
);

export default ContentMetadataCommentSourceCssClasses;



// WEBPACK FOOTER //
// ./approval_queues/components/activity_feed/helpers.js